import script from "./CustomerOriginEcharts.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerOriginEcharts.vue?vue&type=script&setup=true&lang=js"

import "./CustomerOriginEcharts.vue?vue&type=style&index=0&id=f661a106&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f661a106"]])

export default __exports__